import type { Space } from '@mail/cross-sizes-utils';

export type AiGenerateImageStyleType = 'oil' | 'cartoon' | '3d' | 'pixel' | 'anime' | 'cyberpunk' | 'comic' | 'realism';

export enum EAiPhotoGenerationState {
    idle = 'idle',
    proccess = 'proccess',
    complete = 'complete',
}

export interface IAiGenerateImageRequest {
    prompt: string;
    style?: AiGenerateImageStyleType;
}

export interface IAiGenerationState {
    generation: {
        state: EAiPhotoGenerationState;
        percentage?: number;
        image?: string;
        size?: Space;
    };
}

export interface IGenerateImageEnd {
    image: string;
    size: Space;
}
